/**
 * Demo adapter — minimal stubs used by BotworkContext in demo mode.
 * The real task state machine lives in TaskContext (via web-client).
 */

import type { DemoAgent } from "@/lib/app-types";

export interface DemoTaskEvent {
  taskId: string;
  status: "thinking" | "working" | "delivered" | "approved" | "error";
  progress?: number;
  statusLine?: string;
  agentName?: string;
}

export function demoGetAgents(): Promise<DemoAgent[]> {
  // No static agents — real agents are fetched via GET /api/web/agents.
  return Promise.resolve([]);
}

export function demoCreateTask(_description: string): Promise<{ id: string }> {
  const id = `demo-task-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  return Promise.resolve({ id });
}

export function demoApproveTask(_taskId: string, _rating: number): Promise<void> {
  return Promise.resolve();
}
